import { render } from "./NewCardPlaceholder.vue?vue&type=template&id=499a30cd&scoped=true"
import script from "./NewCardPlaceholder.vue?vue&type=script&lang=js"
export * from "./NewCardPlaceholder.vue?vue&type=script&lang=js"

import "./NewCardPlaceholder.vue?vue&type=style&index=0&id=499a30cd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-499a30cd"]])

export default __exports__